<template>
  <app-layout title="Organisations">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />
      <!-- progress bar start from here -->
      
      <upgrade-progressstep step="3"></upgrade-progressstep>
      <!-- progress end  -->
      <br />
      <section>
        <div class="container">
          <div class=" gap-4" style="display: flex;">
            <!-- left side end -->
            <div class="bigitem border-2 border-grey-600 bg-white mb-4 ">
              <!-- left billing -->

              <div class="font-semibold text-lg text-left mx-4 pt-4 leading-none">
                Your Organisations
              </div>
              <h6 class="text-left mx-4 text-sm mb-3">
                Select an organisation to deploy the product or
                <jet-responsive-nav-link
                  @click="showCreatePopup()"
                  class="text-green-500"
                  >create new</jet-responsive-nav-link
                >
              </h6>

             
              <div class="mx-4 mb-3">
                <!-- cards 1 start -->
                <label
                  v-for="(d, b) in this.accounts"
                  :key="b"
                  @click="getAccountData(d.id)"
                  class="card"
                >
                  <input name="plan" class="radio" type="radio" />

                  <span class="text-left plan-details">
                    <div class="font-semibold text-lg">{{ d.name }} </div>
                  </span>
                </label>

                <!-- cards end -->
              </div>
              

              <!-- left billing end -->
            </div>
            <!-- left side end -->
            <!-- ... -->
            <!-- right side start -->
         <div class=" smallitem border-2 border-grey-600 bg-white mb-4 ">
              <div class="mx-4 my-4">
                <div class="flex justify-between">
                  <div class="font-semibold text-lg">Product Details</div>
                  <i class="dx-icon-edit"></i>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-500 text-sm">Product Name</span>
                  <span class="text-gray-500 text-sm">{{ sideProductName }}</span>
                </div>

                <div class="flex justify-between">
                  <span class="text-gray-500 text-sm">Subsciption Plan</span>
                  <span class="text-gray-500 text-sm">{{ sideSubPlanName }}</span>
                </div>

                <div class="flex justify-between border-b-2 border-gray-600">
                  <span class="text-gray-500 text-sm">Subsciption Price</span>
                  <span class="text-gray-500 text-sm">{{ sideSubPrice }}</span>
                </div>
             
                <div class="flex justify-end mt-4">
                  <!-- <button
                    href="#"
                    type="button"
                    class="rounded-md font-bold text-gray-700 px-4 py-2"
                    style="background-color: #cdcdcd"
                  >
                    <i class="dx-icon-chevrondoubleleft"></i>
                   
                    Back
                  </button> -->

                  <jet-responsive-nav-link
                    @click="goToHost()"
                    type="button"
                    class=" next
                      rounded-md
                      font-bold
                      bg-green-500
                      text-white
                      px-4
                      py-2 
                    "
                  >
                    Next
                    <i class="dx-icon-chevrondoubleright"></i>
                  </jet-responsive-nav-link>
                </div>
              </div>
            </div>
            <!-- Right end -->
          </div>

          <!-- pop up for quick create -->
          <DxPopup
            v-model:visible="createPopupVisible"
            :drag-enabled="true"
            :show-close-button="true"
            :close-on-outside-click="false"
            :show-title="true"
            :resizeEnabled="true"
            :title="creatTitle"
          >
            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="before"
              :options="saveButtonOptions"
            />
            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              :options="closeButtonOptions"
            />

            <DxScrollView width="100%" height="100%">
              <BsOnBoardForm
                :routeDef="this.routeDef"
                :createDef="this.accountsDef"
                :modelData="modelData"
                ref="onboardAccountformRenderer"
              />
            </DxScrollView>
          </DxPopup>

          <!-- pop to if product  is already is deployed -->
          <!-- pop up for quick create -->
          <DxPopup
            v-model:visible="productPopupVisible"
            :drag-enabled="true"
            :show-close-button="true"
            :close-on-outside-click="true"
            :show-title="true"
            :resizeEnabled="true"
            :title="creatTitle"
          >
            <div>
              <h6>This product is already deployed with This organisation.</h6>
            </div>
          </DxPopup>
        </div>
      </section>

     
    </div>
  </app-layout>
</template>

   <script>
   import Progressstep from "../Views/Components/Progressbar.vue"
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import BsEditForm from "@include/forms/BsEditForm.vue";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";
import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import UpgradeProgressstep from "../Views/Components/UpgradeProgressbar.vue";

export default {
  props: {
    productId: String,
    subscriptionPriceId: String,
    subscriptionPlanId: String,
    //userTanantsList Array with default value
    sideProductName: String,
    sideSubPlanName: String,
    sideSubPrice: String,
    accounts: {
      type: Array,
      default: () => [],
    },

    // quick create def for accounts
    accountsDef: {
      type: Array,
      default: [],
    },
  },
  components: {
    Progressstep,
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    BsEditForm,
    BsOnBoardForm,
    DxScrollView,
    UpgradeProgressstep
  },
  data() {
    return {
      tenantData: null,
      productData: null,
      selectedAccountId: null,
      title: "Organisations",
      routeDef: "tenant-lists",
      createPopupVisible: false,
      productPopupVisible: false,
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveRecord,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },
    };
  },
  methods: {
    goToHost() {
      var data = {
        productId: this.productId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptionPriceId: this.subscriptionPriceId,
        accountId: this.selectedAccountId,
        sideProductName: this.sideProductName,
        sideSubPlanName: this.sideSubPlanName,
        sideSubPrice: this.sideSubPrice,
      };
      
      if(this.selectedAccountId!=null){
      this.$inertia.post(route("marketplaces.billingaccounts"), data);

      }
      else{
        alert("Please Select Any Organisation !!")
      }

    },

    getAccountData(id) {
      this.selectedAccountId = id;
    },

    showCreatePopup() {
      this.createPopupVisible = true;
    },

    showAlert() {
      this.productPopupVisible = true;
    },
    saveRecord() {
      this.$inertia.post(
        route(
          "onboard.accounts",
          this.$refs.onboardAccountformRenderer.formData
        )
      );
      this.createPopupVisible = false;
    },
  },
  mounted() {
    // $(window).bind('beforeunload',function(){
    console.log("Accounts", this.subscriptionPriceId);
    //   return null;
    // });
    // this.getOrganisation();
    // this.getProductId();
  },
};
</script>


<style>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

.img-company {
  width: 50px;
  height: 50px;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

/* after steps */
.card {
  background-color: #fff;
  border-radius: var(--card-radius);
  position: relative;
}
.card:hover {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}

.radio {
  font-size: inherit;
  margin: 0;
  position: absolute;
  right: calc(var(--card-padding) + var(--radio-border-width));
  top: calc(var(--card-padding) + var(--radio-border-width));
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .radio {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #fff;
    border: var(--radio-border-width) solid var(--color-gray);
    border-radius: 50%;
    cursor: pointer;
    height: var(--radio-size);
    outline: none;
    transition: background 0.2s ease-out, border-color 0.2s ease-out;
    width: var(--radio-size);
  }
  .radio::after {
    border: var(--radio-border-width) solid #fff;
    border-top: 0;
    border-left: 0;
    content: "";
    display: block;
    height: 0.75rem;
    left: 25%;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -50%);
    width: 0.375rem;
  }
  .radio:checked {
    background: var(--color-green);
    border-color: var(--color-green);
  }

  .card:hover .radio {
    border-color: var(--color-dark-gray);
  }
  .card:hover .radio:checked {
    border-color: var(--color-green);
    --tw-ring-color: rgba(27, 243, 167, 0.886);
    background: var(--color-green);
  }
}
 [type="radio"] {
color:var(--color-green);
 }
  input[type="radio"] {
 --tw-ring-color: rgba(27, 243, 167, 0.886)  !important;
}
.plan-details {
  border: var(--radio-border-width) solid var(--color-gray);
  border-radius: var(--card-radius);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: var(--card-padding);
  transition: border-color 0.2s ease-out;
}

.card:hover .plan-details {
  border-color: var(--color-dark-gray);
}

.radio:checked ~ .plan-details {
  border-color: var(--color-green);
}

.radio:focus ~ .plan-details {
  box-shadow: 0 0 0 2px var(--color-dark-gray);
}

.radio:disabled ~ .plan-details {
  color: var(--color-dark-gray);
  cursor: default;
}

/* .radio:disabled ~ .plan-details .plan-type {
  color: var(--color-dark-gray);
} */

.card:hover .radio:disabled ~ .plan-details {
  border-color: var(--color-gray);
  box-shadow: none;
}

.card:hover .radio:disabled {
  border-color: var(--color-gray);
}

.hidden-visually {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
:root {
  --card-line-height: 1.2em;
  --card-padding: 1em;
  --card-radius: 0.5em;
  --color-green: #0ecb8f;
  --color-gray: #e2ebf6;
  --color-dark-gray: #c4d1e1;
  --radio-border-width: 2px;
  --radio-size: 1.5em;
}
h4 {
  margin-bottom: 0rem;
  /* font-weight: 500; */
  line-height: 1.2;
}
p {
  margin-bottom: -3px;
}
/* button start */
.dx-icon-edit {
  font: 20px/1 DXIcons;
}
/* .next {
  margin-top: 190px;
} */
.left-cont{
  /* height: 400px; */
  /* min-height: 400px; */
}
/* .right-cont{

} */
.bigitem {
   /* This will be twice as big as the small item. */
   -webkit-flex: 2 0 0; 
   flex: 2 0 0; 
}
.smallitem {
   -webkit-flex: 1 0 0;
   flex: 1 0 0;
   height: 20%;
   min-height:200px;
    
}
</style>

